export default {
    page_title: 'Lista widget',
    create_new: 'Creaza un widget nou',
    new: 'Widget Nou',
    update: 'Modifica Widget',
    price: 'Pretul',
    no_items: 'Nu a fost găsit niciun rezultat',
    reduced_price: 'Pretul Redus',
    errors: {
        image_required: 'Imaginea este obligatorie pentru toate randurile',
        slug: 'Id-ul este obligatorie pentru toate randurile',
        config_id_required: 'Id-ul de config este obligatorie pentru toate randurile',
        product_required: 'Produsul este obligatoriu pentru toate randurile',

    },
    form_actions: {
        select_type: 'Selecteaza Tipul',
        select_product: 'Selecteaza Produsul',
        select_image: 'Selecteaza Imaginea',
        select_id: 'Adauga un id',
        select_config_id: 'Adauga Config ID',
        select_id_info: 'E nevoie pentru a fi usor identificat de catre alte surse',
        select_provider: 'Selecteaza Furnizorul',
        add_row: "Adaugă Produs",
        save: "Salvează"
    },
    reason: {
        inactive_product: 'Produsul a fost dezactivat de catre furnizor',
        invalid_id: 'Produsul a fost sters din Baza de date, sau a fost modificat de catre furnizor',
    },
    table: {
        header: {
            data: 'Data',
            id: 'Id',
            type: 'Tipul',
            available_start: 'Valabil din data de',
            available_end: 'Valabil pana la data de',
            created_at: 'Data Crearii',
            updated_at: 'Data Modificarii',
            status: 'Status',
        }
    },
    modal: {
        select_product_title: 'Selecteaza Produsul',
        provider: 'Furnizor',
        select_provider_first: 'Selecteaza Furnizorul',
        name: 'Nume',
        brand: 'Brand',
        price: 'Pret',
        action: 'Actiune',
    }

}